export default "__VITE_ASSET__CF8KlcRb__"